var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "not-found-container" }, [
    _c(
      "div",
      { staticClass: "not-found-content" },
      [
        _c("i", { staticClass: "el-icon-warning-outline not-found-icon" }),
        _c("h2", { staticClass: "not-found-title" }, [_vm._v("页面开发中")]),
        _c("p", { staticClass: "not-found-desc" }, [
          _vm._v("该功能模块正在开发中，敬请期待...")
        ]),
        _c("p", { staticClass: "not-found-path" }, [
          _vm._v("路径: " + _vm._s(_vm.$route.path))
        ]),
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.goBack } },
          [_vm._v("返回上一页")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }